import type { VisibilityCondition, VisibilityRule } from '../editor/types'

export function evaluateCondition(
  condition: VisibilityCondition,
  variableValues: Record<string, number | string | boolean>
): boolean {
  const raw = variableValues[condition.variable]
  if (raw === undefined) return false

  const { operator, value } = condition

  if (operator === '==' || operator === '!=') {
    // Compare by native type — coerce string "true"/"false" for booleans
    const eq = String(raw) === String(value)
    return operator === '==' ? eq : !eq
  }

  // Numeric comparisons
  const a = Number(raw)
  const b = Number(value)
  if (isNaN(a) || isNaN(b)) return false

  switch (operator) {
    case '>': return a > b
    case '<': return a < b
    case '>=': return a >= b
    case '<=': return a <= b
    default: return false
  }
}

export function evaluateVisibility(
  rule: VisibilityRule | undefined,
  variableValues: Record<string, number | string | boolean>
): boolean {
  if (!rule || rule.conditions.length === 0) return true

  if (rule.logic === 'or') {
    return rule.conditions.some((c) => evaluateCondition(c, variableValues))
  }
  return rule.conditions.every((c) => evaluateCondition(c, variableValues))
}
